var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRoundEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop - 19",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1049,
    transform: "translate(-120 -228)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277581"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -14,
    width: 400,
    height: 214,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277580"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20 -14H370V45H-20V-14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 44.5H-20V45.5H370V44.5Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277581_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic:round-email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.6665 5.33331H5.33317C3.8665 5.33331 2.67984 6.53331 2.67984 7.99998L2.6665 24C2.6665 25.4666 3.8665 26.6666 5.33317 26.6666H26.6665C28.1332 26.6666 29.3332 25.4666 29.3332 24V7.99998C29.3332 6.53331 28.1332 5.33331 26.6665 5.33331ZM26.1332 11L16.7065 16.8933C16.2798 17.16 15.7198 17.16 15.2932 16.8933L5.8665 11C5.73281 10.9249 5.61573 10.8235 5.52236 10.7019C5.42898 10.5803 5.36125 10.441 5.32327 10.2925C5.28529 10.1439 5.27784 9.98923 5.30138 9.83772C5.32492 9.68622 5.37895 9.54106 5.46021 9.41105C5.54147 9.28103 5.64827 9.16885 5.77414 9.08131C5.90001 8.99376 6.04233 8.93266 6.1925 8.90171C6.34266 8.87076 6.49755 8.8706 6.64778 8.90124C6.79801 8.93189 6.94045 8.99269 7.0665 9.07998L15.9998 14.6666L24.9332 9.07998C25.0592 8.99269 25.2017 8.93189 25.3519 8.90124C25.5021 8.8706 25.657 8.87076 25.8072 8.90171C25.9573 8.93266 26.0997 8.99376 26.2255 9.08131C26.3514 9.16885 26.4582 9.28103 26.5395 9.41105C26.6207 9.54106 26.6748 9.68622 26.6983 9.83772C26.7218 9.98923 26.7144 10.1439 26.6764 10.2925C26.6384 10.441 26.5707 10.5803 26.4773 10.7019C26.3839 10.8235 26.2669 10.9249 26.1332 11Z",
    fill: "#202020",
    fillOpacity: 0.7
  }))))), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -14,
    width: 400,
    height: 214,
    rx: 5,
    stroke: "#E0E0E0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1049,
    fill: "white",
    transform: "translate(-120 -228)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -14,
    width: 400,
    height: 214,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundEmail);
export default __webpack_public_path__ + "static/media/ic_round-email.93ac704991f4bb90db975b1c2215106d.svg";
export { ForwardRef as ReactComponent };